"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useState } from "react"
import { useRouter } from "next/navigation"
import dynamic from "next/dynamic"
import SuggestAGroupButton from "../../pages/homePageGroupSearch/EmptySearchResults/SuggestAGroupButton"
import useSessionAttributes from "../../../lib/auth/useSessionAttributes"
import updateWarningMessage from "../../../graphql/mutations/snackbarMessage/updateWarningMessage"

const SuggestGroupDialog = dynamic(() => import("../SuggestGroupDialog"), {
  loading: () => <p>Loading...</p>,
  ssr: false,
})

function SuggestGroupSection() {
  const { userId } = useSessionAttributes()
  const router = useRouter()
  const [isSuggestGroupOpen, setIsSuggestGroupOpen] = useState(false)

  const handleCloseSuggestGroupDialog = () => {
    setIsSuggestGroupOpen(false)
  }

  const handleSuggestGroupClick = () => {
    if (userId) {
      setIsSuggestGroupOpen(true)
    } else {
      updateWarningMessage("Please login to request a group")
      router.push("/login")
    }
  }

  return (
    <>
      <div className="flex flex-col justify-center items-center bg-[#F4F4F4] h-[387px] mt-[30px] mb-[70px] rounded-[20px] px-[20px] text-center">
        <div className="font-bebas text-[36px] tracking-[2.52px] mb-[24px]">
          Can't find the group you're looking for?
        </div>
        <div className="tracking-[.57px] text-[19px] mb-[41px]">
          Let us find it for you. Tell us what you're looking for, and we'll work to
          make it happen!
        </div>
        <SuggestAGroupButton
          onClick={handleSuggestGroupClick}
          text={"Request a group"}
        />
      </div>
      {isSuggestGroupOpen && (
        <SuggestGroupDialog
          key={"suggest-group-dialog"}
          onClose={handleCloseSuggestGroupDialog}
          open={isSuggestGroupOpen}
          userId={userId}
        />
      )}
    </>
  )
}

export default SuggestGroupSection
